import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/constants";

export default function WhatsAppButton() {
  const message = encodeURIComponent(
    "Hi Forage Team, I'm interested in your veterinary products / contract manufacturing. Please share details."
  );
  return (
    <a
      data-testid="whatsapp-floating-btn"
      href={`https://wa.me/${CONTACT.whatsapp}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[100] bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:-translate-y-1 hover:scale-105 transition-transform flex items-center justify-center group"
    >
      <MessageCircle size={26} />
      <span className="absolute right-full mr-3 bg-white text-[#0B2545] text-sm font-medium px-3 py-1.5 rounded-md shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        Chat with us
      </span>
    </a>
  );
}
